import { setThemeCollection } from "@store/Framework/ThemeConfiguration";
import common from "@store/Themes/common";

const themes = { common };

export type ThemeName = keyof typeof themes;
export default setThemeCollection(themes, "common");
